module.exports = __webpack_public_path__ + "static/media/casis_thumb.df22f1d5.webp";